<template>
  <div id="app">
    <Head_Modules v-if="!isAdmin"></Head_Modules>
    <router-view/>
    <Foot_Modules v-if="!isAdmin"></Foot_Modules>
    <OnlineCustomer v-if="!isAdmin"></OnlineCustomer>
  </div>
</template>

<script>
import axios from 'axios'
import Head_Modules from '@/components/head_modules.vue'
import Foot_Modules from '@/components/foot_modules.vue'
import OnlineCustomer from '@/components/onlineCustomer.vue'
export default {
  name: 'App',
  components: {
    Head_Modules,
    Foot_Modules,
    OnlineCustomer,
  },
  computed: {
    isAdmin() {
      return this.$route.path.startsWith('/admin')
    }
  },
  mounted() {
    this.trackVisit()
  },
  watch: {
    '$route'() {
      this.trackVisit()
    }
  },
  methods: {
    trackVisit() {
      if (this.isAdmin) return
      try {
        axios.post('/api/stats/track', { path: this.$route.path }, { timeout: 3000 })
      } catch (e) { /* 静默上报 */ }
    }
  }
}
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
*{
  box-sizing: border-box;
  text-align: left;
}
p{
  margin: 0;
}
img{
  display: block;
}
body{
  margin: 0 auto;
  max-width: 2560px;
  background-color: #F3F3F3;
  font-size: 14px;
  font-family: Arial,"Microsoft YaHei","SimSun";
}
.content_width{width: 1200px;margin: 0 auto;}
.icon_svg {
  width: 1.5em;
  height: 1.5em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
.font_size_12{
  font-size: 12px;
}
</style>
